


  
  

  var faCaretUp = {
    prefix: 'fass',
    iconName: 'caret-up',
    icon: [
      320,
      512,
      [],
      'f0d8',
      
      'M0 272L160 128 320 272v48H0V272z'
      
    ]
  };

  



export {

  faCaretUp,
  

};
